import { Skeleton } from '@/components/ui/skeleton';

interface FanPageSkeletonProps {
  primaryColor?: string;
}

export function FanPageSkeleton({ primaryColor = '#1e3a5f' }: FanPageSkeletonProps) {
  return (
    <div className="min-h-screen flex flex-col w-full">
      {/* Hero Section Skeleton */}
      <div 
        className="relative px-6 pt-10 pb-8"
        style={{ backgroundColor: '#1a1a2e' }}
      >
        <div className="relative max-w-md mx-auto">
          {/* Teams and score skeleton */}
          <div className="flex items-center justify-center gap-6 mb-6">
            <Skeleton className="w-16 h-16 rounded-full bg-white/20" />
            <div className="text-center">
              <Skeleton className="w-16 h-6 mx-auto mb-2 bg-white/20" />
              <Skeleton className="w-24 h-4 mx-auto bg-white/10" />
            </div>
            <Skeleton className="w-16 h-16 rounded-full bg-white/20" />
          </div>
          
          {/* Seat info skeleton */}
          <div className="flex items-center justify-center gap-2">
            <Skeleton className="w-20 h-4 bg-white/10" />
            <span className="text-white/50">•</span>
            <Skeleton className="w-12 h-4 bg-white/10" />
            <span className="text-white/50">•</span>
            <Skeleton className="w-12 h-4 bg-white/10" />
          </div>
        </div>
      </div>

      {/* Action Buttons Section Skeleton */}
      <div 
        className="flex-1 px-6 py-6"
        style={{ 
          backgroundColor: primaryColor,
          borderTopLeftRadius: '24px',
          borderTopRightRadius: '24px',
          marginTop: '-12px',
          position: 'relative',
          zIndex: 10
        }}
      >
        <div className="max-w-md mx-auto space-y-3">
          {/* Simulate 4-5 action buttons */}
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="flex items-center gap-4 px-5 py-4 rounded-xl"
              style={{ backgroundColor: 'rgba(255,255,255,0.1)' }}
            >
              <Skeleton className="w-10 h-10 rounded-lg bg-white/20" />
              <Skeleton className="w-32 h-5 bg-white/20" />
              <div className="ml-auto">
                <Skeleton className="w-5 h-5 rounded-full bg-white/10" />
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Sponsor footer skeleton */}
      <div className="py-6 flex justify-center" style={{ backgroundColor: primaryColor }}>
        <Skeleton className="h-10 w-32 bg-white/10" />
      </div>
    </div>
  );
}
